// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"Searchbar_searchBar__3bReI","clear":"Searchbar_clear___XfC2","input":"Searchbar_input__3oOQB"};